import CustomIcon from '../CustomIcon/CustomIcon';

function ServiceCard({ icon, onClick, text, color, tipoFiltro, descriptionFilter }) {
  return (
    <div
      className="col-xs-4 col-card-label"
      onClick={() => onClick({ text, color, icon, show: true, tipoFiltro, descriptionFilter })}
    >
      <div className="service-card ">
        <CustomIcon className="icon-mask" icon={icon} color={color} />
        <span>{text}</span>
      </div>
    </div>
  );
}

export default ServiceCard;
